import React from 'react';
import { Link } from 'react-router-dom';
import { FaCogs, FaChartLine, FaTools, FaTruck } from 'react-icons/fa';
import './ServicesSection.css';

const ServicesSection = () => {
  const services = [
    {
      id: 1,
      title: 'Custom Tool Design',
      description: 'Tailored solutions for your specific manufacturing needs with precision engineering, using high-quality materials for optimal performance.',
      icon: <FaCogs />,
    },
    {
      id: 2,
      title: 'Tech Consultation',
      description: 'Expert advice from our team of specialists to optimize your production processes, improve efficiency, and select the perfect tools for your application.',
      icon: <FaChartLine />,
    },
    {
      id: 3,
      title: 'Tool Reconditioning',
      description: 'Restore your worn tungsten carbide and diamond tools to like-new condition, extending their lifespan and maximizing your investment.',
      icon: <FaTools />,
    },
    {
      id: 4,
      title: 'Global Distribution',
      description: 'Fast and reliable delivery of our products to industries worldwide, including aerospace, automotive, electronics, and precision manufacturing.',
      icon: <FaTruck />,
    },
  ];

  return (
    <section id="services" className="services-section home-section">
      <div className="section-header">
        <h2 className="section-title">Our Services</h2>
        <p className="section-subtitle">
          Comprehensive solutions to enhance your manufacturing capabilities through precision engineering and dedicated expertise
        </p>
      </div>

      <div className="services-grid">
        {services.map((service) => (
          <Link to="/contact" className="service-card-link" key={service.id}>
            <div className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="section-action">
        <Link to="/contact" className="btn">
          Contact Us About Our Services
        </Link>
      </div>
    </section>
  );
};

export default ServicesSection;
